import React from 'react';
import './DevBuildBadge.css';

/**
 * Localhost-only badge showing when the current dev server process started.
 * Helps catch stale-browser-tab confusion after a backend/frontend restart -
 * killing and restarting `npm start` bumps this timestamp, so a tab still
 * showing the old time is a tab that needs a hard refresh.
 */
const DevBuildBadge = () => {
  if (window.location.hostname !== 'localhost') return null;

  const buildTimeSeconds = Number(process.env.REACT_APP_BUILD_TIME);
  if (!buildTimeSeconds) return null;

  const startedAt = new Date(buildTimeSeconds * 1000).toLocaleTimeString();

  return (
    <div className="dev-build-badge" title="When this dev server process last started">
      🔧 Server started: {startedAt}
    </div>
  );
};

export default DevBuildBadge;
